var _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line0, _line1, _line10, _line11, _line12, _line13, _line14, _line15, _line16, _line17, _line18, _line19, _line20, _line21, _line22, _line23, _line24, _line25, _line26, _line27, _line28, _line29, _line30, _line31, _line32, _line33, _line34, _line35, _line36, _line37, _line38, _line39, _line40, _line41, _line42, _line43, _line44, _line45, _line46, _line47, _line48, _line49, _line50, _line51, _line52, _line53, _line54, _line55, _line56, _line57, _line58, _line59, _line60, _line61, _line62, _line63, _line64, _line65, _line66;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStripesBlue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "stripes") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    y1: 0.5,
    x2: 200,
    y2: 0.5,
    fill: "none",
    stroke: "#1E00BE",
    strokeMiterlimit: 10
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    y1: 199.5,
    x2: 200,
    y2: 199.5,
    fill: "none",
    stroke: "#1E00BE",
    strokeMiterlimit: 10
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    y1: 3.47,
    x2: 200,
    y2: 3.47,
    fill: "none",
    stroke: "#1E00BE",
    strokeMiterlimit: 10
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    y1: 6.44,
    x2: 200,
    y2: 6.44,
    fill: "none",
    stroke: "#1E00BE",
    strokeMiterlimit: 10
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    y1: 9.41,
    x2: 200,
    y2: 9.41,
    fill: "none",
    stroke: "#1E00BE",
    strokeMiterlimit: 10
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    y1: 12.38,
    x2: 200,
    y2: 12.38,
    fill: "none",
    stroke: "#1E00BE",
    strokeMiterlimit: 10
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    y1: 15.35,
    x2: 200,
    y2: 15.35,
    fill: "none",
    stroke: "#1E00BE",
    strokeMiterlimit: 10
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    y1: 18.32,
    x2: 200,
    y2: 18.32,
    fill: "none",
    stroke: "#1E00BE",
    strokeMiterlimit: 10
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    y1: 21.29,
    x2: 200,
    y2: 21.29,
    fill: "none",
    stroke: "#1E00BE",
    strokeMiterlimit: 10
  })), _line0 || (_line0 = /*#__PURE__*/React.createElement("line", {
    y1: 24.26,
    x2: 200,
    y2: 24.26,
    fill: "none",
    stroke: "#1E00BE",
    strokeMiterlimit: 10
  })), _line1 || (_line1 = /*#__PURE__*/React.createElement("line", {
    y1: 27.23,
    x2: 200,
    y2: 27.23,
    fill: "none",
    stroke: "#1E00BE",
    strokeMiterlimit: 10
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    y1: 30.2,
    x2: 200,
    y2: 30.2,
    fill: "none",
    stroke: "#1E00BE",
    strokeMiterlimit: 10
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    y1: 33.17,
    x2: 200,
    y2: 33.17,
    fill: "none",
    stroke: "#1E00BE",
    strokeMiterlimit: 10
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    y1: 36.14,
    x2: 200,
    y2: 36.14,
    fill: "none",
    stroke: "#1E00BE",
    strokeMiterlimit: 10
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    y1: 39.11,
    x2: 200,
    y2: 39.11,
    fill: "none",
    stroke: "#1E00BE",
    strokeMiterlimit: 10
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    y1: 42.08,
    x2: 200,
    y2: 42.08,
    fill: "none",
    stroke: "#1E00BE",
    strokeMiterlimit: 10
  })), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    y1: 45.05,
    x2: 200,
    y2: 45.05,
    fill: "none",
    stroke: "#1E00BE",
    strokeMiterlimit: 10
  })), _line16 || (_line16 = /*#__PURE__*/React.createElement("line", {
    y1: 48.02,
    x2: 200,
    y2: 48.02,
    fill: "none",
    stroke: "#1E00BE",
    strokeMiterlimit: 10
  })), _line17 || (_line17 = /*#__PURE__*/React.createElement("line", {
    y1: 50.99,
    x2: 200,
    y2: 50.99,
    fill: "none",
    stroke: "#1E00BE",
    strokeMiterlimit: 10
  })), _line18 || (_line18 = /*#__PURE__*/React.createElement("line", {
    y1: 53.96,
    x2: 200,
    y2: 53.96,
    fill: "none",
    stroke: "#1E00BE",
    strokeMiterlimit: 10
  })), _line19 || (_line19 = /*#__PURE__*/React.createElement("line", {
    y1: 56.93,
    x2: 200,
    y2: 56.93,
    fill: "none",
    stroke: "#1E00BE",
    strokeMiterlimit: 10
  })), _line20 || (_line20 = /*#__PURE__*/React.createElement("line", {
    y1: 59.9,
    x2: 200,
    y2: 59.9,
    fill: "none",
    stroke: "#1E00BE",
    strokeMiterlimit: 10
  })), _line21 || (_line21 = /*#__PURE__*/React.createElement("line", {
    y1: 62.87,
    x2: 200,
    y2: 62.87,
    fill: "none",
    stroke: "#1E00BE",
    strokeMiterlimit: 10
  })), _line22 || (_line22 = /*#__PURE__*/React.createElement("line", {
    y1: 65.84,
    x2: 200,
    y2: 65.84,
    fill: "none",
    stroke: "#1E00BE",
    strokeMiterlimit: 10
  })), _line23 || (_line23 = /*#__PURE__*/React.createElement("line", {
    y1: 68.81,
    x2: 200,
    y2: 68.81,
    fill: "none",
    stroke: "#1E00BE",
    strokeMiterlimit: 10
  })), _line24 || (_line24 = /*#__PURE__*/React.createElement("line", {
    y1: 71.78,
    x2: 200,
    y2: 71.78,
    fill: "none",
    stroke: "#1E00BE",
    strokeMiterlimit: 10
  })), _line25 || (_line25 = /*#__PURE__*/React.createElement("line", {
    y1: 74.75,
    x2: 200,
    y2: 74.75,
    fill: "none",
    stroke: "#1E00BE",
    strokeMiterlimit: 10
  })), _line26 || (_line26 = /*#__PURE__*/React.createElement("line", {
    y1: 77.72,
    x2: 200,
    y2: 77.72,
    fill: "none",
    stroke: "#1E00BE",
    strokeMiterlimit: 10
  })), _line27 || (_line27 = /*#__PURE__*/React.createElement("line", {
    y1: 80.69,
    x2: 200,
    y2: 80.69,
    fill: "none",
    stroke: "#1E00BE",
    strokeMiterlimit: 10
  })), _line28 || (_line28 = /*#__PURE__*/React.createElement("line", {
    y1: 83.66,
    x2: 200,
    y2: 83.66,
    fill: "none",
    stroke: "#1E00BE",
    strokeMiterlimit: 10
  })), _line29 || (_line29 = /*#__PURE__*/React.createElement("line", {
    y1: 86.63,
    x2: 200,
    y2: 86.63,
    fill: "none",
    stroke: "#1E00BE",
    strokeMiterlimit: 10
  })), _line30 || (_line30 = /*#__PURE__*/React.createElement("line", {
    y1: 89.6,
    x2: 200,
    y2: 89.6,
    fill: "none",
    stroke: "#1E00BE",
    strokeMiterlimit: 10
  })), _line31 || (_line31 = /*#__PURE__*/React.createElement("line", {
    y1: 92.57,
    x2: 200,
    y2: 92.57,
    fill: "none",
    stroke: "#1E00BE",
    strokeMiterlimit: 10
  })), _line32 || (_line32 = /*#__PURE__*/React.createElement("line", {
    y1: 95.54,
    x2: 200,
    y2: 95.54,
    fill: "none",
    stroke: "#1E00BE",
    strokeMiterlimit: 10
  })), _line33 || (_line33 = /*#__PURE__*/React.createElement("line", {
    y1: 98.51,
    x2: 200,
    y2: 98.51,
    fill: "none",
    stroke: "#1E00BE",
    strokeMiterlimit: 10
  })), _line34 || (_line34 = /*#__PURE__*/React.createElement("line", {
    y1: 101.49,
    x2: 200,
    y2: 101.49,
    fill: "none",
    stroke: "#1E00BE",
    strokeMiterlimit: 10
  })), _line35 || (_line35 = /*#__PURE__*/React.createElement("line", {
    y1: 104.46,
    x2: 200,
    y2: 104.46,
    fill: "none",
    stroke: "#1E00BE",
    strokeMiterlimit: 10
  })), _line36 || (_line36 = /*#__PURE__*/React.createElement("line", {
    y1: 107.43,
    x2: 200,
    y2: 107.43,
    fill: "none",
    stroke: "#1E00BE",
    strokeMiterlimit: 10
  })), _line37 || (_line37 = /*#__PURE__*/React.createElement("line", {
    y1: 110.4,
    x2: 200,
    y2: 110.4,
    fill: "none",
    stroke: "#1E00BE",
    strokeMiterlimit: 10
  })), _line38 || (_line38 = /*#__PURE__*/React.createElement("line", {
    y1: 113.37,
    x2: 200,
    y2: 113.37,
    fill: "none",
    stroke: "#1E00BE",
    strokeMiterlimit: 10
  })), _line39 || (_line39 = /*#__PURE__*/React.createElement("line", {
    y1: 116.34,
    x2: 200,
    y2: 116.34,
    fill: "none",
    stroke: "#1E00BE",
    strokeMiterlimit: 10
  })), _line40 || (_line40 = /*#__PURE__*/React.createElement("line", {
    y1: 119.31,
    x2: 200,
    y2: 119.31,
    fill: "none",
    stroke: "#1E00BE",
    strokeMiterlimit: 10
  })), _line41 || (_line41 = /*#__PURE__*/React.createElement("line", {
    y1: 122.28,
    x2: 200,
    y2: 122.28,
    fill: "none",
    stroke: "#1E00BE",
    strokeMiterlimit: 10
  })), _line42 || (_line42 = /*#__PURE__*/React.createElement("line", {
    y1: 125.25,
    x2: 200,
    y2: 125.25,
    fill: "none",
    stroke: "#1E00BE",
    strokeMiterlimit: 10
  })), _line43 || (_line43 = /*#__PURE__*/React.createElement("line", {
    y1: 128.22,
    x2: 200,
    y2: 128.22,
    fill: "none",
    stroke: "#1E00BE",
    strokeMiterlimit: 10
  })), _line44 || (_line44 = /*#__PURE__*/React.createElement("line", {
    y1: 131.19,
    x2: 200,
    y2: 131.19,
    fill: "none",
    stroke: "#1E00BE",
    strokeMiterlimit: 10
  })), _line45 || (_line45 = /*#__PURE__*/React.createElement("line", {
    y1: 134.16,
    x2: 200,
    y2: 134.16,
    fill: "none",
    stroke: "#1E00BE",
    strokeMiterlimit: 10
  })), _line46 || (_line46 = /*#__PURE__*/React.createElement("line", {
    y1: 137.13,
    x2: 200,
    y2: 137.13,
    fill: "none",
    stroke: "#1E00BE",
    strokeMiterlimit: 10
  })), _line47 || (_line47 = /*#__PURE__*/React.createElement("line", {
    y1: 140.1,
    x2: 200,
    y2: 140.1,
    fill: "none",
    stroke: "#1E00BE",
    strokeMiterlimit: 10
  })), _line48 || (_line48 = /*#__PURE__*/React.createElement("line", {
    y1: 143.07,
    x2: 200,
    y2: 143.07,
    fill: "none",
    stroke: "#1E00BE",
    strokeMiterlimit: 10
  })), _line49 || (_line49 = /*#__PURE__*/React.createElement("line", {
    y1: 146.04,
    x2: 200,
    y2: 146.04,
    fill: "none",
    stroke: "#1E00BE",
    strokeMiterlimit: 10
  })), _line50 || (_line50 = /*#__PURE__*/React.createElement("line", {
    y1: 149.01,
    x2: 200,
    y2: 149.01,
    fill: "none",
    stroke: "#1E00BE",
    strokeMiterlimit: 10
  })), _line51 || (_line51 = /*#__PURE__*/React.createElement("line", {
    y1: 151.98,
    x2: 200,
    y2: 151.98,
    fill: "none",
    stroke: "#1E00BE",
    strokeMiterlimit: 10
  })), _line52 || (_line52 = /*#__PURE__*/React.createElement("line", {
    y1: 154.95,
    x2: 200,
    y2: 154.95,
    fill: "none",
    stroke: "#1E00BE",
    strokeMiterlimit: 10
  })), _line53 || (_line53 = /*#__PURE__*/React.createElement("line", {
    y1: 157.92,
    x2: 200,
    y2: 157.92,
    fill: "none",
    stroke: "#1E00BE",
    strokeMiterlimit: 10
  })), _line54 || (_line54 = /*#__PURE__*/React.createElement("line", {
    y1: 160.89,
    x2: 200,
    y2: 160.89,
    fill: "none",
    stroke: "#1E00BE",
    strokeMiterlimit: 10
  })), _line55 || (_line55 = /*#__PURE__*/React.createElement("line", {
    y1: 163.86,
    x2: 200,
    y2: 163.86,
    fill: "none",
    stroke: "#1E00BE",
    strokeMiterlimit: 10
  })), _line56 || (_line56 = /*#__PURE__*/React.createElement("line", {
    y1: 166.83,
    x2: 200,
    y2: 166.83,
    fill: "none",
    stroke: "#1E00BE",
    strokeMiterlimit: 10
  })), _line57 || (_line57 = /*#__PURE__*/React.createElement("line", {
    y1: 169.8,
    x2: 200,
    y2: 169.8,
    fill: "none",
    stroke: "#1E00BE",
    strokeMiterlimit: 10
  })), _line58 || (_line58 = /*#__PURE__*/React.createElement("line", {
    y1: 172.77,
    x2: 200,
    y2: 172.77,
    fill: "none",
    stroke: "#1E00BE",
    strokeMiterlimit: 10
  })), _line59 || (_line59 = /*#__PURE__*/React.createElement("line", {
    y1: 175.74,
    x2: 200,
    y2: 175.74,
    fill: "none",
    stroke: "#1E00BE",
    strokeMiterlimit: 10
  })), _line60 || (_line60 = /*#__PURE__*/React.createElement("line", {
    y1: 178.71,
    x2: 200,
    y2: 178.71,
    fill: "none",
    stroke: "#1E00BE",
    strokeMiterlimit: 10
  })), _line61 || (_line61 = /*#__PURE__*/React.createElement("line", {
    y1: 181.68,
    x2: 200,
    y2: 181.68,
    fill: "none",
    stroke: "#1E00BE",
    strokeMiterlimit: 10
  })), _line62 || (_line62 = /*#__PURE__*/React.createElement("line", {
    y1: 184.65,
    x2: 200,
    y2: 184.65,
    fill: "none",
    stroke: "#1E00BE",
    strokeMiterlimit: 10
  })), _line63 || (_line63 = /*#__PURE__*/React.createElement("line", {
    y1: 187.62,
    x2: 200,
    y2: 187.62,
    fill: "none",
    stroke: "#1E00BE",
    strokeMiterlimit: 10
  })), _line64 || (_line64 = /*#__PURE__*/React.createElement("line", {
    y1: 190.59,
    x2: 200,
    y2: 190.59,
    fill: "none",
    stroke: "#1E00BE",
    strokeMiterlimit: 10
  })), _line65 || (_line65 = /*#__PURE__*/React.createElement("line", {
    y1: 193.56,
    x2: 200,
    y2: 193.56,
    fill: "none",
    stroke: "#1E00BE",
    strokeMiterlimit: 10
  })), _line66 || (_line66 = /*#__PURE__*/React.createElement("line", {
    y1: 196.53,
    x2: 200,
    y2: 196.53,
    fill: "none",
    stroke: "#1E00BE",
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStripesBlue);
export default __webpack_public_path__ + "static/media/stripesBlue.ac9dc7a66def68c435907561d154b4f2.svg";
export { ForwardRef as ReactComponent };